import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import OrderService from '../../../services/orders/orderService';
import NumberFormat from 'react-number-format';
import './listOrder.scss';

class ListOrder extends Component {
    constructor() {
        super();
        this.state = {
            status: 0,
            orders: [],
            isLoading: true,
            searchKey: '',
            skipCount: 0,
            maxResultCount: 20,
            totalOrder: 0,
            pageNo: 1
        };
        this.syncOrders = this.syncOrders.bind(this);
        this.handleClickPrev = this.handleClickPrev.bind(this);
        this.handleClickNext = this.handleClickNext.bind(this);
        this.handleClickRow = this.handleClickRow.bind(this);
    }

    componentDidMount() {
        this.syncOrders();
    }

    syncOrders() {
        this.setState({ isLoading: true });
        OrderService.GetCurrentUserOrders(this.state.status, this.state.searchKey, this.state.skipCount, this.state.maxResultCount).then(res => {
            this.setState({
                orders: res.data.result.items,
                totalOrder: res.data.result.totalCount,
                totalPage: Math.ceil(res.data.result.totalCount / this.state.maxResultCount)
            });
        }).finally(() => {
            this.setState({ isLoading: false });
        });
    }

    handleClickPrev() {
        if (this.state.pageNo > 1) {
            var pageNo = this.state.pageNo - 1;
            this.setState({
                pageNo: pageNo,
                skipCount: (pageNo - 1) * this.state.maxResultCount
            }, () => {
                this.syncOrders();
            })
        }
    }

    handleClickNext() {
        if (this.state.pageNo < this.state.totalPage) {
            var pageNo = this.state.pageNo + 1;
            this.setState({
                pageNo: pageNo,
                skipCount: (pageNo - 1) * this.state.maxResultCount
            }, () => {
                this.syncOrders();
            });
        }
    }

    handleClickRow(order) {
        this.props.history.push("/orders/" + order.id);
    }

    render() {
        const { isLoading, orders, pageNo, totalPage, totalOrder } = this.state;
        return (
            <div className="search-results-wrapper is-billing-table banking-dashboard banking-dashboard-v3">
                <div className="search-results-body">
                    <div className="columns">
                        <div className="column">
                            <div className="tabs-wrapper">
                                <div className="tabs-inner">
                                    <div className={"flex-table is-compact has-loader " + (isLoading ? "has-loader-active min-height" : "")}>
                                        <div className="flex-table-header">
                                            <span className="flex-small">Invoice #</span>
                                            <span className="flex-medium">Tanggal</span>
                                            <span className="">Produk</span>
                                            <span className="flex-small">Paket</span>
                                            <span className="flex-medium">Harga</span>
                                            <span className="flex-medium">Total Bayar</span>
                                            <span className="flex-small">Status</span>
                                            <span className="flex-small"></span>
                                        </div>
                                        {
                                            !isLoading ?
                                                (
                                                    (orders.length > 0) ?
                                                        orders.map((order, index) => (
                                                            <div className='flex-table-item' key={index}>
                                                                <div className="flex-table-cell flex-small" data-th="Invoice">
                                                                    <span className="light-text">
                                                                        <a href={"/orders/" + order.id}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                this.handleClickRow(order)
                                                                            }}>
                                                                            <span className="dark-text has-text-weight-medium">
                                                                                {order.invoiceNo}
                                                                            </span>
                                                                        </a>
                                                                    </span>
                                                                </div>
                                                                <div className="flex-table-cell flex-medium" data-th="Tanggal">
                                                                    <span className="light-text">{moment(order.creationTime).local().format('LLL')}</span>
                                                                </div>
                                                                <div className="flex-table-cell " data-th="Produk">
                                                                    <span className="light-text">{order.product.name}</span>
                                                                </div>
                                                                <div className="flex-table-cell flex-small" data-th="Paket">
                                                                    <span className="light-text">{order.productSubscriptionPlan.typeName}</span>
                                                                </div>
                                                                <div className="flex-table-cell flex-medium" data-th="Harga">
                                                                    <span className="light-text">
                                                                        {
                                                                            order.amount === 0 ?
                                                                                <span>FREE</span>
                                                                                :
                                                                                <NumberFormat value={order.amount} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                                                        }
                                                                    </span>
                                                                </div>
                                                                <div className="flex-table-cell flex-medium" data-th="Total Bayar">
                                                                    <span className="light-text">
                                                                        {
                                                                            order.paidAmount === 0 ?
                                                                                <span>-</span>
                                                                                :
                                                                                <NumberFormat value={order.paidAmount} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                                                        }
                                                                    </span>
                                                                </div>
                                                                <div className="flex-table-cell flex-small" data-th="Status">
                                                                    <span className="light-text">
                                                                        <span className={"tag is-rounded " + (order.status === 10 ? "is-danger" : order.status === 20 ? "is-warning" : order.status === 30 ? "is-success" : "")}>{order.statusName}</span>
                                                                    </span>
                                                                </div>
                                                                <div className="flex-table-cell flex-small" data-th="">
                                                                    <a href={"/orders/" + order.id} target="_blank" onClick={(e) => { e.preventDefault(); this.handleClickRow(order) }} rel="noreferrer" className="button is-dark-outlined">Details</a>
                                                                </div>
                                                            </div>
                                                        )
                                                        ) :
                                                        <div className="section-placeholder">
                                                            <div className="placeholder-content">
                                                                <img className="light-image" src="images/illustrations/placeholders/search-4.svg" alt="" />
                                                                <img className="dark-image" src="images/illustrations/placeholders/search-4-dark.svg" alt="" />
                                                                <h3 className="dark-inverted">Anda belum mempunyai Orderan</h3>
                                                                <p>Saat ini Anda belum mempunyai Orderan. Silahkan order produk Ruang Trader.</p>
                                                            </div>
                                                        </div>
                                                )
                                                :
                                                <div className="h-loader-wrapper">
                                                    <div className="loader is-large is-loading"></div>
                                                </div>
                                        }
                                    </div>
                                </div>
                                {
                                    totalPage > 0 ?
                                        <div className="is-clearfix">
                                            <div className="buttons has-addons is-scrollable mt-2 mb-0 is-pulled-left">
                                                {
                                                    pageNo === 1 ? <></> : <button className={"button h-button is-raised"} onClick={this.handleClickPrev}>Prev</button>
                                                }
                                                {
                                                    pageNo === totalPage ? <></> : <button className={"button is-primary h-button is-raised"} onClick={this.handleClickNext}>Next</button>
                                                }
                                            </div>
                                            <div className="is-pulled-left mt-3">
                                                <span className="ml-3 dark-inverted">Jumlah Order: {totalOrder}, page {pageNo} of {totalPage}</span>
                                            </div>
                                        </div>
                                        :
                                        <></>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(ListOrder);